import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import I18n from 'i18n-js';
import { RCAlertBox, buttonClassName, RCTextWithIcon } from '@reverbdotcom/commons/src/rc';
import InfoCircleSvg from '@reverbdotcom/commons/design-system/icons/core/info-circle.svg?component';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import experiments from '@reverbdotcom/commons/src/experiments';
import { Paths } from '../../../shared/url_helpers';
import { core_apimessages_Listing_SeedType as SeedType } from '../../../../schemas/rql';


interface IExternalProps {
  listingId?: string;
  seedId?: string;
  seedType?: SeedType;
}

type IProps = IExternalProps & WithRouterProps;

const NAG_ID = 'sell_form_v2_opt_out';

function getRedirectPath({ location, listingId, seedId, seedType = SeedType.ComparisonShoppingPage }) {
  if (listingId) {
    return Paths.sellFormEditListing.expand({ listingId, query: { section: 'review' } });
  }

  const { promotional_token } = location?.query ?? {};

  let params: any = {};
  if (promotional_token) {
    params.promotional_token = promotional_token;
  }

  if (seedId) {
    params = { ...params, seed_id: seedId, seed_type: seedType };
  }

  return Paths.sellFormNewListing.expand({ query: { ...params } });
}

export function SellFormOptIn({ listingId, seedId, seedType, location }: IProps) {
  if (!useExpEnabled(experiments.SELL_FORM_V2)) { return null; }

  const optInLink = Paths.showNagAlertAndRedirect.expand({
    nagId: NAG_ID,
    redirect_to: getRedirectPath({ location, listingId, seedId, seedType }),
  });

  return (
    <div className="sell-form-opt-in">
      <RCAlertBox type="info">
        <RCTextWithIcon svgComponent={InfoCircleSvg} placement="left" >
          {I18n.t('discovery.sellForm.optIn.title')}
        </RCTextWithIcon>
        <div className="sell-form-opt-in__cta">
          <CoreLink
            to={optInLink}
            className={buttonClassName({ variant: 'secondary', fullWidth: true })}
          >
            {I18n.t('discovery.sellForm.optIn.CTA')}
          </CoreLink>
        </div>
      </RCAlertBox>
    </div>
  );
}

export default withRouter(SellFormOptIn);
